var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button, ButtonMode, ButtonSize, ButtonVariant } from '../../Components/Button';
import { EditIcon } from '../../Components/Icons';
import { MedicationListStatus } from '../../Contracts/MedicationListsSearchFilter.Request';
import { primary } from '../../Styles/Colours';
import { EditMedicationListDialog } from '../EditMedicationListDialog/EditMedicationListDialog';
export function EditMedicationListButton(props) {
    var medicationList = props.medicationList, onComplete = props.onComplete, buttonProps = __rest(props, ["medicationList", "onComplete"]);
    var _a = __read(useState(false), 2), showDialog = _a[0], setShowDialog = _a[1];
    if (props.medicationList.status === MedicationListStatus.Published)
        return null;
    return (React.createElement(Button, __assign({}, buttonProps, { size: ButtonSize.small, mode: ButtonMode.border, variant: ButtonVariant.light, onClick: function () {
            setShowDialog(true);
        }, startIcon: React.createElement(EditIcon, { noPadding: true, size: '20', color: primary }) }),
        "Edit",
        showDialog && (React.createElement(EditMedicationListDialog, { medicationList: medicationList, onComplete: onComplete, onClose: function () {
                setShowDialog(false);
            } }))));
}
